class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.deskNavSearchIcon = document.getElementById('desktop-header-search');
    this.mobNavSearchIcon = document.getElementById('header-mobile-search');
    this.closeSearchIcon = document.getElementById('search-autocomplete-close');
    this.input = this.querySelector('input[type="search"]');
    this.hotRightNowPanel = this.querySelector('#hot-right-now-panel');
    this.suggestionsBox = this.querySelector('#suggestions-box');
    this.ssPanel = this.querySelector('#searchspring-autocomplete-panel');
    this.pageLoadId = this.generateUUID();

    this.personalizationPromise = this.fetchPersonalizationParams();

    if (this.deskNavSearchIcon) {
      this.deskNavSearchIcon.addEventListener('click', () => {
        this.showHotRightNowAndTrending();
        this.input.focus();
      });
    }

    if (this.mobNavSearchIcon) {
      this.mobNavSearchIcon.addEventListener('click', () => {
        this.showHotRightNowAndTrending();
        this.input.focus();
      });
    }

    if (this.closeSearchIcon) {
      this.closeSearchIcon.addEventListener('click', () => {
        this.input.value = '';
        this.showHotRightNowAndTrending();
        this.input.focus();
      });
    }

    this.input.addEventListener(
      'input',
      this.debounce(() => this.onChange(), 300).bind(this)
    );

    this.input.addEventListener('focus', () => {
      if (!this.input.value.trim()) {
        this.showHotRightNowAndTrending();
      }
    });
  }

  async onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.showHotRightNowAndTrending();
      return;
    }

    // Hide Hot Right Now, show suggestions and results
    if (this.hotRightNowPanel) this.hotRightNowPanel.style.display = 'none';
    if (this.ssPanel) this.ssPanel.style.display = 'grid';

    this.getSearchSuggestions(searchTerm);
    await this.getSearchResults(searchTerm);
  }

  showHotRightNowAndTrending() {
    if (this.hotRightNowPanel) this.hotRightNowPanel.style.display = 'block';
    if (this.ssPanel) {
      this.ssPanel.innerHTML = '';
      this.ssPanel.style.display = 'none';
    }
    if (this.suggestionsBox) {
      this.suggestionsBox.innerHTML = '';
      this.suggestionsBox.style.display = 'block';
      this.fetchTrendingTerms();
    }
  }

  bindSuggestionClicks() {
    const items = this.suggestionsBox.querySelectorAll('.suggestion-item');
    items.forEach((item) => {
      item.addEventListener('click', () => {
        const term = item.getAttribute('data-term') || item.textContent;
        window.location.href = `/search?q=${encodeURIComponent(term)}`;
      });
    });
  }

  async fetchPersonalizationParams() {
    const userId = this.getCookie('ssUserId') || '';
    const cart = this.getCookie('ssCartProducts') || '';
    const lastViewed = this.getCookie('ssViewedProducts') || '';
    const url = new URL('https://tr8yw9.a.searchspring.io/api/personalization/preflightCache');
    url.searchParams.set('siteId', 'tr8yw9');
    if (userId) url.searchParams.set('userId', userId);
    if (cart) url.searchParams.set('cart', encodeURIComponent(cart));
    if (lastViewed) url.searchParams.set('lastViewed', encodeURIComponent(lastViewed));
    if (userId) url.searchParams.set('shopper', userId);

    try {
      const res = await fetch(url.toString());
      if (!res.ok) {
        throw new Error(`Personalization API error: ${res.status}`);
      }
      const text = await res.text();
      if (!text) {
        this.personalization = {};
        return;
      }
      const data = JSON.parse(text);
      this.personalization = {
        shopper: userId,
        cart: cart,
        lastViewed: lastViewed,
        ...data
      };
    } catch (error) {
      console.error('Error fetching personalization data:', error);
    }
  }

  async getSearchResults(searchTerm) {
    if (this.personalizationPromise) await this.personalizationPromise;
    const siteId = 'tr8yw9';
    const userId = this.getCookie('ssUserId') || '';
    const sessionId = this.getCookie('ssSessionIdNamespace') || '';
    const domain = window.location.href;

    // Always get latest values from cookies
    const shopper = this.getCookie('ssUserId') || '';
    const cart = this.getCookie('ssCartProducts') || '';
    const lastViewed = this.getCookie('ssViewedProducts') || '';

    let fullUrl = `https://${siteId}.a.searchspring.io/api/search/autocomplete.json?q=${encodeURIComponent(
      searchTerm,
    )}&siteId=${siteId}&resultsPerPage=6&userId=${userId}&sessionId=${sessionId}&pageLoadId=${this.pageLoadId}&domain=${encodeURIComponent(domain)}`;

    if (shopper) fullUrl += `&shopper=${encodeURIComponent(shopper)}`;
    if (cart) fullUrl += `&cart=${encodeURIComponent(cart)}`;
    if (lastViewed) fullUrl += `&lastViewed=${encodeURIComponent(lastViewed)}`;

    fetch(fullUrl)
      .then((response) => {
        if (!response.ok) {
          this.showHotRightNowAndTrending();
          throw new Error(`Error ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const html = data?.results;
        // Detect Searchspring's "no results" HTML
        const isNoResults = html && html.includes('id="searchspring-no_results"');

        if (this.ssPanel) {
          if (html && html.trim().length > 0 && !isNoResults) {
            this.ssPanel.innerHTML = `
              <h2 class="autocomplete-heading">Relevant Products</h2>
              <div class="autocomplete-grid">
                ${html}
              </div>
            `;

            // --- INTELLISUGGEST CLICK TRACKING REPLACEMENT ---
            const siteId = 'tr8yw9';
            const grid = this.ssPanel.querySelector('.autocomplete-grid');
            if (grid) {
              grid.querySelectorAll('.item .image a, .item .name a').forEach(link => {
                const onmousedown = link.getAttribute('onmousedown');
                if (
                  onmousedown &&
                  onmousedown.includes('SearchSpring.Catalog.intellisuggest')
                ) {
                  const match = onmousedown.match(/intellisuggest\(.*?,\s*'([^']+)''+,\s*'([^']+)'/);
                  if (match) {
                    const intellisuggestData = match[1].replace(/'+$/, '');
                    const intellisuggestSignature = match[2];
                    link.setAttribute(
                      'onmousedown',
                      `IntelliSuggest.clickItem(this, { siteId: '${siteId}', intellisuggestData: '${intellisuggestData}', intellisuggestSignature: '${intellisuggestSignature}' })`
                    );
                  }
                }
              });

              // --- FROM £ and DETAILS WRAPPER ---
              grid.querySelectorAll('.item').forEach(item => {
                const name = item.querySelector('.name');
                const price = item.querySelector('.price');
                if (name && price && !name.parentElement.classList.contains('details')) {
                  if (!price.textContent.trim().startsWith('From £')) {
                    price.textContent = `From £${price.textContent.trim()}`;
                  }
                  const details = document.createElement('div');
                  details.className = 'details';
                  details.appendChild(name);
                  details.appendChild(price);
                  const compare = item.querySelector('.compare');
                  if (compare) {
                    item.insertBefore(details, compare);
                  } else {
                    item.appendChild(details);
                  }
                }
              });
            }

            this.ssPanel.style.display = 'grid';
            if (this.hotRightNowPanel) this.hotRightNowPanel.style.display = 'none';
          } else {
            this.ssPanel.innerHTML = '';
            this.ssPanel.style.display = 'none';
            if (this.hotRightNowPanel) this.hotRightNowPanel.style.display = 'block';
            this.fetchTrendingTerms();
          }
        }
      })
      .catch((error) => {
        this.showHotRightNowAndTrending();
        console.error('Autocomplete API Error:', error);
      });
  }

  getSearchSuggestions(searchTerm) {
    const siteId = 'tr8yw9';
    const url = `https://${siteId}.a.searchspring.io/api/suggest/query?q=${encodeURIComponent(
      searchTerm
    )}&siteId=${siteId}&suggestionCount=4&language=en`;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Suggest API error: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const suggestions = [];
        const suggestedText = data?.suggested?.text;
        if (suggestedText && suggestedText.toLowerCase() !== searchTerm.toLowerCase()) {
          suggestions.push(suggestedText);
        }
        if (Array.isArray(data?.alternatives)) {
          data.alternatives.forEach((alt) => {
            if (alt?.text) suggestions.push(alt.text);
          });
        }
        this.renderSuggestions(suggestions);
      })
      .catch((error) => {
        console.error('Suggest API Error:', error);
      });
  }

  fetchTrendingTerms() {
    const siteId = 'tr8yw9';
    const limit = 6;
    const url = `https://${siteId}.a.searchspring.io/api/suggest/trending?siteId=${siteId}&limit=${limit}`;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const trendingQueries = data?.trending?.queries || [];
        if (trendingQueries.length > 0) {
          const html = `<h2 class="suggestions-title">Top Searches</h2>` +
            trendingQueries
              .map(
                (query) =>
                  `<div class="suggestion-item" data-term="${query.searchQuery}">${query.searchQuery}</div>`
              )
              .join('');
          this.suggestionsBox.innerHTML = html;
          this.suggestionsBox.style.display = 'block';
          this.bindSuggestionClicks();
        } else {
          this.suggestionsBox.innerHTML = '';
          this.suggestionsBox.style.display = 'none';
        }
      })
      .catch((err) => {
        this.suggestionsBox.innerHTML = '';
        this.suggestionsBox.style.display = 'none';
        console.error('Trending API Error:', err);
      });
  }

  renderSuggestions(suggestions) {
    if (!this.suggestionsBox) return;
    this.suggestionsBox.innerHTML = '';

    if (suggestions.length === 0) {
      this.suggestionsBox.style.display = 'none';
      return;
    }

    // Add heading for suggestions
    const heading = document.createElement('h2');
    heading.className = 'suggestions-title';
    heading.textContent = 'Top Suggestions';
    this.suggestionsBox.appendChild(heading);

    suggestions.forEach((text) => {
      const item = document.createElement('div');
      item.className = 'suggestion-item';
      item.textContent = text;
      item.setAttribute('data-term', text);
      item.addEventListener('click', () => {
        window.location.href = `/search?q=${encodeURIComponent(text)}`;
      });
      this.suggestionsBox.appendChild(item);
    });

    this.suggestionsBox.style.display = 'block';
    this.bindSuggestionClicks();
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      },
    );
  }

  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('predictive-search', PredictiveSearch);
});
